/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import { type RadioItem, RadioGroup } from '@vvoyages/shared-ui/ui';

import styles from './ClaimBookingRadioGroup.module.scss';
import { MatchingClient } from '../../types/ClaimBookingTypes';

type ClaimBookingRadioGroupProps = {
  sailors?: MatchingClient[];
  selectedSailor?: MatchingClient;
  onChange: (value: MatchingClient) => void;
  labelFunction: (sailor: MatchingClient, index: number) => React.ReactNode;
};

const ClaimBookingRadioGroup = ({
  sailors = [],
  selectedSailor,
  onChange,
  labelFunction,
}: ClaimBookingRadioGroupProps) => {
  const [value, setValue] = useState<string | null>(selectedSailor?.clientId ?? null);

  useEffect(() => {
    if (selectedSailor?.clientId) {
      setValue(selectedSailor.clientId);
    }
  }, [selectedSailor]);

  const handleChange = (selectedId: string) => {
    setValue(selectedId);

    const matchedSailor = sailors.find((sailor) => sailor.clientId === selectedId);

    if (matchedSailor) {
      onChange(matchedSailor);
    }
  };

  const radioItems: RadioItem[] = sailors.map((sailor, index) => ({
    value: sailor?.clientId as string,
    label: String(labelFunction(sailor, index)),
    ariaLabel: `Sailor option ${index + 1}`,
    isRequired: true,
  }));

  return (
    <div className={styles.radioContainer}>
      <RadioGroup
        name="claim-booking-radio-sailor-select"
        items={radioItems}
        value={value}
        onChange={handleChange}
        direction="column"
        isRequired
        iconOnRight
        showLastDivider
        tabIndex={0}
      />
    </div>
  );
};

export default ClaimBookingRadioGroup;
